// extracted by mini-css-extract-plugin
export default {"pageLayout":"LinkTextToAvoidInJobSearches-module__pageLayout___oKCgW"};